<template>
  <div>
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs color="primary" v-model="tabs" class=" " height="80" background-color="#f4f4f4">
          <div class="d-flex align-center px-4  ">
            <v-icon color="primary" class="" size="">mdi-human-male-board-poll</v-icon>
            <h5 class="font-weight-bold headline ml-5">Comercial</h5>

          </div>
          <v-tab class="ml-4">
            <span>Cotações</span>
          </v-tab>
          
          <v-tab class="ml-4">
            <span>OPEC</span>
          </v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Propostas</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
        </v-tabs>
      </template>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <QuotationsList />
        </v-tab-item>

        <v-tab-item>
          <PisProbative />
        </v-tab-item>

        <v-tab-item>
          <div class="pa-8 text-center">
            <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
            <h3 class="grey--text mt-4">Propostas</h3>
            <p class="grey--text">Esta funcionalidade está em desenvolvimento</p>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import QuotationsList from '@/components/comercial/QuotationsList.vue';
import PisProbative from '@/components/comercial/PisProbative.vue';

export default {
  name: "ComercialTable",
  
  components: {
    QuotationsList,
    PisProbative
  },
  data() {
    return {
      tabs: 0,
    };
  },
  mounted() {
    this.loadTabs()
  },
  watch: {
    '$route.params.tab'() {
      this.loadTabs()
    },
    'tabs'(nV) {
      let query = []
      const keepKeys = nV === 1 ? ['q', 'grid', 'uri', 'type'] : ['q']
      for (let key in this.$route.query) {
        if (nV != 0 && keepKeys.includes(key)) {
          query.push(`${key}=${this.$route.query[key]}`)
        }
      }
      const qstring = query.length ? `?${query.join('&')}` : ''

      if (nV == 0 && this.$route.fullPath != `/app/comercial/quotations${qstring}`) {
        this.$router.replace(`/app/comercial/quotations${qstring}`)
      } else if (nV == 1 && this.$route.fullPath != `/app/comercial/opec${qstring}`) {
        this.$router.replace(`/app/comercial/opec${qstring}`)
      } else if (nV == 2 && this.$route.fullPath != `/app/comercial/propostas${qstring}`) {
        this.$router.replace(`/app/comercial/propostas${qstring}`)
      }
    }
  },
  methods: {
    loadTabs() {
      if (this.$route.params.tab == 'quotations') {
        this.tabs = 0
      } else if (this.$route.params.tab == 'opec') {
        this.tabs = 1
      } else if (this.$route.params.tab == 'propostas') {
        this.tabs = 2
      }
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.v-tab--disabled {
  opacity: 0.6 !important;
}
</style>